import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';

/**
 * Undo an import: hard-deletes the rows it created that are still unclaimed
 * (clients who have since signed in are kept). Returns how many were deleted,
 * plus `keptCount` — unclaimed rows that could not be removed because something
 * outside the import (a claimed sign-in, an admin wallet credit) now references
 * them.
 */
export const useRollbackImportJob = (organizationId: string) => {
  const client = useApiClient();

  return useMutation({
    mutationFn: (jobId: string) =>
      client.fetchApi<{ deletedCount: number; keptCount: number }, undefined>({
        endpoint: `users/imports/${jobId}/rollback?organizationId=${organizationId}`,
        method: 'POST',
      }),
  });
};
